<template>
 
    <el-dialog
      title="品类图标更换"
      :visible.sync="centerDialogVisible"
      v-if="centerDialogVisible"
      width="800px"
      class="dialog"
      center
    >
      <div class="up-contents">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="110px"
          class="demo-ruleForm"
        >
          <el-form-item label="上传图片" prop="url">
            <el-upload
              v-loading="loadingImage"
              element-loading-text="正在上传..."
              action="#"
              :on-preview="handlePictureCardPreview"
              :class="{ hide: url.length == 1 }"
              :file-list="url"
              list-type="picture-card"
              :before-upload="
                    (file) => {
                      return handleBeforeUpload(file, 90, 90);
                    }
                  "
              :http-request="
                (file) => {
                  return uploadFile(file, 'url');
                }
              "
              :before-remove="
                (file, fileList) => {
                  return deleteFile(file, fileList, 'url');
                }
              "
              :limit="1"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>

            <div style="margin-top: 20px;">请上传尺寸为：90x90的图片</div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="tianku">确认</el-button>
      </span>
    </el-dialog>

</template>
<script>

import { postBannerUpload } from "@/api/generalControl/banner";
import { compress } from "image-conversion";
export default {
  components: {  },
  data() {
    return {
      centerDialogVisible: false,
       loadingImage: false,
      //列表页面不同功能参数
      ruleForm: {
        url: "",
      },
      url: [],
      rules: {
        url: [{ required: true, message: "请上传图片", trigger: "blur" }],
      },
    };
  },
  created() {},
  methods: {
    tianku(){
            this.$refs.ruleForm.validate((valid) => {
        if (valid) {
        this.$emit('imgchange',this.ruleForm);
this.centerDialogVisible=false;
        }
      });

    },
        // 上传前校验 —— 限制图片尺寸
    handleBeforeUpload(file, w, h) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
          // 在这里设置你要的宽高限制
          const width = img.width;
          const height = img.height;

          // ========== 示例1：限制必须是 300x300 ==========
          if (width !== w || height !== h) {
            this.$message.error(`图片尺寸必须是 ${w}px × ${h}px`);
            reject(false);
            return;
          }

          // 校验通过
          resolve(true);
        };
      });
    },
    oninit(e){
        this.ruleForm.url=e.radius_pic;
        this.url=[{url:e.radius_pic}]
this.centerDialogVisible=true;
    },
     deleteFile(file, fileList, name) {
      console.log(file, "删除");
      console.log(fileList, "删除");
      this[name] = fileList;
      this.ruleForm[name] = fileList;
    },
     uploadFile(options, name) {
      // 拿到 file
      this.loadingImage = true;
      let file = options.file;
      let date = new Date().getTime();
      console.log(file, "文件");
      console.log(file.size / 1024 / 1024);
      compress(file, 0.9).then((res) => {
        console.log(res);
        console.log(res.size / 1024 / 1024);
        if (res.size / 1024 / 1024 > 50) {
          this.tool.message("图片超过50M,请重新上传", "error");
          this.loadingImage = false;
        } else {
          var event = event || window.event;
          var reader = new FileReader();
          reader.readAsDataURL(res);
          reader.onload = (e) => {
            console.log(e);
            this.uploadImage(e.target.result, name);
          };
        }
      });
    },
    async uploadImage(img, name) {
      try {
        let { data } = await postBannerUpload({ file_data: img });
        this[name] = [{ url: data }];
        this.ruleForm[name] = data;
      } catch (error) {
        console.error("ajax postBannerUpload err", err);
      } finally {
        this.loadingImage = false;
      }
    },
    handlePictureCardPreview(file) {
      console.log("object", file);
    //   this.bigImage = file.url;
    //   this.dialogImage = true;
    },
  },
};
</script>
<style lang="less">
.up-contents {
padding: 20px;
box-sizing: border-box;
}
</style>
